<template>
    <div class="wrapper">
        <div class="row header">
            <div class="col title">
                <p>{{title}}</p>
            </div>
            <loggedin-account v-if="account.name && account.identification" :account="account"/>
        </div>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import loggedinAccount from '@/components/loggedinAccount';

export default {
    props: [
        'title'
    ],
    components: {
        loggedinAccount
    },
    name: 'topbar',
    mixins: [
        Default
    ],
    computed: {
        account: {
            get() {
                return this.$store.getters[this.$store.types.loggedinAccount.getters.get];
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    p {
        font-weight: 400;
        font-size: 18px;
    }
    .header {
        background-color: #e8ebf0;
        padding: .5em;
        min-height: $topBarHeight;
    }
    .title {
        margin: auto;
    }
</style>
